export default __webpack_public_path__ + "static/Plots0020-1b004cccdad52c8f4cf112e9db6295a4.jpg";